module.exports = __webpack_public_path__ + "static/media/HV.c7905d41.png";